import { render } from "./TransactionFeeDialog.vue?vue&type=template&id=18cd37ae&scoped=true"
import script from "./TransactionFeeDialog.vue?vue&type=script&lang=js"
export * from "./TransactionFeeDialog.vue?vue&type=script&lang=js"

import "./TransactionFeeDialog.vue?vue&type=style&index=0&id=18cd37ae&scoped=true&lang=css"
import "./TransactionFeeDialog.vue?vue&type=style&index=1&id=18cd37ae&lang=css"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18cd37ae"]])

export default __exports__